import { valueProps } from '../../../mocks/reports';

export default function ValueSection() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-antonio text-5xl font-bold text-[#272727] text-center mb-20 uppercase">
          What You'll Learn
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {valueProps.map((prop, index) => (
            <div key={index} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6">
                <i className={`${prop.icon} text-5xl text-[#4d4d31]`}></i>
              </div>
              <h3 className="font-antonio text-2xl font-bold text-[#272727] mb-4 uppercase">
                {prop.title}
              </h3>
              <p className="text-base text-[#272727]/60 leading-relaxed mb-8 font-barlow">
                {prop.description}
              </p>
              <a
                href="https://theboloreport.substack.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block border-2 border-[#4d4d31] text-[#4d4d31] px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#4d4d31] hover:text-[#e9eae4] transition-all whitespace-nowrap cursor-pointer font-barlow tracking-wide"
              >
                Learn more
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
